const apiUrl = process.env.REACT_APP_API_URL;
export const getDubtes = async (id_aula : string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${id_aula}/dubtes`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
